import instance from './http.config'
export const uploadFile = (params) => instance.post('/upload/oss', params, {
  headers: {
    'Content-Type': 'multipart/form-data',
    'Authentication-token': localStorage.getItem('auth_token')
  }
})
export const uploadFileAliYun = params => instance.post(params.host, params.fd, {
  headers: {'Content-Type': 'multipart/form-data'
  }
})

export const uploadTeaching = (playerId, activityId, params) => instance.post(`/player/materials/${playerId}/${activityId}/summary_material`, params)

// 用户是否可以进入反思节段
export const playerShouldEnterTeachingRefelction = (playerId, activityId) => instance.get(`/player/materials/${playerId}/${activityId}/contest_progress`)
// 上传反思材料
let socketUrl = process.env.SOCKET_API + '/emit'
export const sendUploadSummarymaterialSuccess = params => instance.post(socketUrl, params)



// WEBPACK FOOTER //
// ./src/service/teaching.js